<template>
    <b-modal size="xl" button-size="sm" :title="prefix + title" @hidden="cancelar" @close="cancelar" v-model="showModal"
        hide-footer>
        <b-card bg-variant="light">
            <div class="d-flex align-items-center justify-content-center">
                <small>{{ produto.descricaoProduto }}</small>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <small>{{ produto.lote }}</small>
            </div>
        </b-card>

        <b-form-row>
            <b-col>
                <LgFinderPageMarca id="finderPageMarca" v-model="form.marca" label="Marca:" :prefix="[prefix + title]"
                    @input="handleMarcaSelect" />
            </b-col>
            <b-col>
                <LgFinderPageModelo id="finderPageModelo" v-model="form.modelo" label="Modelo:"
                    :prefix="[prefix + title]" @input="handleModeloSelect" />
            </b-col>
            <b-col class="d-flex align-items-center justify-content-around">
                <b-button id="localizar-ic" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                    @click="load">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="search" />
                    </div>
                    <b-tooltip target="localizar-ic" title="Localizar"></b-tooltip>
                </b-button>


                <b-button id="limpar-ic" class="my-2" size="sm" style="height: 20px" pill variant="primary"
                    @click="clearForm">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="eraser" />
                    </div>
                    <b-tooltip target="limpar-ic" title="Limpar"></b-tooltip>
                </b-button>

            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col lg="2" sm="12">
                <lg-form-date invalidFeedback="A data de deve ser informada!" v-model="form.dataDe"
                    label="Data de Atesto:" description="" />
            </b-col>

            <b-col lg="2" sm="12">
                <lg-form-date invalidFeedback="A data limite deve ser informada!" v-model="form.dataAte" label="Até"
                    description="" />
            </b-col>
        </b-form-row>
        <b-card>
            <b-table responsive small :busy="busy" :items="safeRecords" :fields="fields" hover show-empty>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #empty>
                    <p>Nenhum registro encontrado</p>
                </template>
            </b-table>
            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
                        totalPage
                        }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</template>
<script>
import ResourceService from "@/core/api/ResourceService"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import LgFinderPageMarca from "../Finders/LgFinderPageMarca.vue"
import LgFinderPageModelo from "../Finders/LgFinderPageModelo.vue"
import LgFormDate from "../../core/components/Form/LgFormDate.vue"
import moment from "moment"

export default {
    props: {
        produto: {
            type: Object,
            required: true,
        },

        title: {
            type: String,
            default: "Item Bem Consumo",
        },

        prefix: {
            type: String,
            default: "",
        },
    },

    components: {
        LgFinderPageMarca,
        LgFinderPageModelo,
        LgFormDate,
    },

    mixins: [FormResourceMixin, ListResourceMixin],

    beforeMount() {
        this.$service = new ResourceService(
            "/api/itens-bem-consumo/itens-almoxarifado"
        )
    },

    mounted() {
        this.load()
    },
    watch: {
        page() {
            this.load()
        },
    },

    data() {
        return {
            busy: false,
            records: [],
            perPage: 10,
            perPageOptions: [10, 20, 50, 100],
            showModal: true,
            descricaoProduto: this.produto.descricao,
            lote: this.produto.lote,
            form: {
                marca: {},
                modelo: {},
                dataDe: "",
                dataAte: "",
            },
        }
    },

    methods: {
        async load() {
            let filtro = {}

            if (this.form.marca.id) {
                filtro.marcaId = this.form.marca.id
            }
            if (this.form.modelo.id) {
                filtro.modeloId = this.form.modelo.id
            }
            if (this.form.dataDe) {

                filtro.dataDe = new Date(this.form.dataDe).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }
            if (this.form.dataAte) {
                filtro.dataAte = new Date(this.form.dataAte).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }
            if (this.produto.lote !== "Sem Lote") {
                filtro.lote = this.produto.lote
            }
            filtro.produtoId = this.produto.idProduto
            filtro.almoxarifadoId = this.produto.idAlmoxarifado

            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            })
                .then(response => {
                    this.records = response.content
                    this.total = response.totalElements
                    this.totalPage = response.totalPages
                })
                .finally(() => {
                    this.busy = false
                })
        },

        clearForm() {
            this.form = {
                marca: {},
                modelo: {},
                dataDe: "",
                dataAte: "",
            }
            this.load();
        },

        handleMarcaSelect(marca) {
            this.form.marca = marca
            this.load();

        },

        handleModeloSelect(modelo) {
            this.form.modelo = modelo
            this.load();
        },

        cancelar() {
            this.showModal = false
            this.$emit("close")
        },

        formatSaldo(item) {
            const entrada = item.quantidadeEntrada || 0
            const saida = item.quantidadeSaida || 0
            return entrada - saida
        },
    },

    computed: {
        fields() {
            return [
                { key: "marca", label: "Marca" },
                { key: "modelo", label: "Modelo" },
                {
                    key: "itemBemConsumo.dataVencimento",
                    label: "Validade",
                    formatter: value => {
                        return value ? moment(value).format("DD/MM/YYYY") : " "
                    },
                },

                {
                    key: "dataAtesto", label: "Data de Atesto", formatter: value => {
                        return value ? moment(value).format("DD/MM/YYYY") : " "
                    },
                },

                {
                    key: "quantidadeEntrada",
                    label: "Entrada",
                },
                {
                    key: "quantidadeSaida",
                    label: "Saída",
                },
                {
                    key: "saldo",
                    label: "Saldo",
                    formatter: (value, key, item) => this.formatSaldo(item),
                },
            ]
        },

        hasRecords() {
            return Array.isArray(this.records) && this.records.length > 0
        },

        safeRecords() {
            return this.records || []
        },

        formatOperacao(item, opToSearch) {
            return console.log(item, opToSearch)
        },
    },
}
</script>
